import axios from 'axios'
import library from '../../../utils/Library'

export const addUserOrganizationCorpEntities = async (body) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') + '/addUserOrganizationCorpEntities'

  return await axios({
    url: URL,
    method: 'POST',
    data: body,
    headers: {
      Authorization: `Bearer ${TOKEN}`
    }
  })
}
